import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { RootState } from "../store";
import { logoutAction } from "../actions/auth";
import { HIDE_LOGOUT_MODAL } from "../actions/types";
import Swal from "sweetalert2";

const LogoutConfirmationModal: React.FC = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { isVisible } = useSelector((state: RootState) => state.logoutModal);

	const handleConfirm = () => {
		dispatch(logoutAction() as any);
		dispatch({ type: HIDE_LOGOUT_MODAL });
	};

	// Prevent ESC key from closing the modal
	useEffect(() => {
		const handleEscape = (e: KeyboardEvent) => {
			if (e.key === "Escape" && isVisible) {
				e.preventDefault();
				e.stopPropagation();
			}
		};

		if (isVisible) {
			document.addEventListener("keydown", handleEscape);
			// Prevent body scroll when modal is open
			document.body.style.overflow = "hidden";
		}

		return () => {
			document.removeEventListener("keydown", handleEscape);
			document.body.style.overflow = "unset";
		};
	}, [isVisible]);

	useEffect(() => {
		if (isVisible) {
			Swal.fire({
				// title: t('Error! Please Login Again'),
				width: 350,
				text: t("Error! Please Login Again"),
				iconHtml: `<img src="/icons/logout-warning.png" width="70" height="70" alt="warning"/>`,
				showConfirmButton: true,
				confirmButtonText: t("Confirm"),
				allowOutsideClick: false,
				allowEscapeKey: false,
				customClass: {
					popup: "logout-alert-popup",
					title: "logout-alert-title",
					confirmButton: "logout-alert-button",
				},
				didClose: () => {
					dispatch({ type: HIDE_LOGOUT_MODAL });
				},
			}).then((result) => {
				if (result.isConfirmed) {
					handleConfirm();
				}
			});
		}
	}, [isVisible]);

	return null;
};

export default LogoutConfirmationModal;
